import { render, staticRenderFns } from "./GoogleSearch.vue?vue&type=template&id=52c45dd2"
import script from "./GoogleSearch.vue?vue&type=script&lang=ts"
export * from "./GoogleSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports